import React from 'react'

export const ohioSetupVars = {
  siteId: 'ohio',
  pathPrefix: '/oh',
  menuHeader: "Discover Ohio's Solution for:",
  appUrl: 'https://oh.headed2.com',
  logoImg: '/images/assets/ohio/horizontal/dark.svg',
  headerTitle: `The Ohio CareerExplorer is a system designed for Ohio`
}
